import React, { useLayoutEffect } from 'react';
import classNames from 'classnames';
import cls from './ProgressbarCircle.module.css';
import { declension } from '../../helpers/declension';

interface ProgressbarCircleProps {
    classes?: string;
    percent: number;
    value: number;
    valueSign: string;
    estimateCount: number;
}

export const ProgressbarCircle = ({
    classes,
    percent,
    value,
    valueSign,
    estimateCount,
}: ProgressbarCircleProps) => {
    useLayoutEffect(() => {
        //@ts-ignore
        DM.initProgressbar(
            document.getElementById('spending_dashboard_chart'),
            `${estimateCount === 0 ? 0 : percent}`
        );
    }, []);

    return (
        <div className={cls.Container}>
            <div className={classNames(cls.ProgressbarCircle, classes)}>
                <div className={cls.ProgressBar}>
                    <div className={cls.ProgressBarPercent}>
                        <div className={cls.ProgressBarPercentText}>
                            {estimateCount === 0 ? 0 : percent}%
                        </div>
                    </div>
                    <canvas id="spending_dashboard_chart" width="116" height="116"></canvas>
                </div>
            </div>
            {estimateCount > 0 && (
                <span className={cls.ProgressBarText}>
                    <span>
                        {estimateCount}{' '}
                        {declension(estimateCount, [
                            i18next.t(
                                'ProgressbarCircle.return.progressBarText.span.declension_estimate'
                            ),
                            i18next.t(
                                'ProgressbarCircle.return.progressBarText.span.declension_estimates'
                            ),
                            i18next.t(
                                'ProgressbarCircle.return.progressBarText.span.declension_estimates_without_s'
                            ),
                        ])}{' '}
                        {i18next.t('ProgressbarCircle.return.progressBarText.span')}
                    </span>
                    <span>
                        {value} {valueSign}
                    </span>
                </span>
            )}
        </div>
    );
};
